export default function PageHeader({ eyebrow, title, subtitle, actions }) {
  return (
    <div className="flex items-end justify-between gap-6 mb-10">
      <div>
        {eyebrow && (
          <div className="text-[10px] font-mono uppercase tracking-widest text-zinc-500 mb-3">
            {eyebrow}
          </div>
        )}
        <h1 className="font-display text-4xl sm:text-5xl font-bold leading-none">{title}</h1>
        {subtitle && <p className="mt-4 text-zinc-400 max-w-2xl">{subtitle}</p>}
      </div>
      {actions && <div className="flex gap-3 shrink-0">{actions}</div>}
    </div>
  );
}
